export const COMMERCIUM_CART_SIZE_PAGE = 128

export const COMMERCIUM_CART_SIZE_SECTION = Math.round(COMMERCIUM_CART_SIZE_PAGE * 0.7)

export const COMMERCIUM_CART_SIZE_TABLE = Math.round(COMMERCIUM_CART_SIZE_PAGE * 0.62)

/** Compact cart for buttons / badges (no 80px floor). */
export const COMMERCIUM_CART_SIZE_INLINE = 56

export const COMMERCIUM_CART_SIZE_MIN = 80

export type CommerciumLoaderVariant = 'page' | 'content' | 'section' | 'table' | 'inline'

export type CommerciumLoaderLayout = 'brand' | 'plain'

export function commerciumCartSizeForVariant(variant: CommerciumLoaderVariant): number {
  if (variant === 'inline') {
    return COMMERCIUM_CART_SIZE_INLINE
  }

  let size: number
  switch (variant) {
    case 'section':
      size = COMMERCIUM_CART_SIZE_SECTION
      break
    case 'table':
      size = COMMERCIUM_CART_SIZE_TABLE
      break
    case 'content':
      size = COMMERCIUM_CART_SIZE_PAGE
      break
    default:
      size = COMMERCIUM_CART_SIZE_PAGE
  }
  return Math.max(size, COMMERCIUM_CART_SIZE_MIN)
}
